import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import Attachment from '@mui/icons-material/Attachment';
import TaskIcon from '@mui/icons-material/Task';

import {
  Avatar,
  Box,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';

import {
  Button,
  Dt,
  Page,
  Typography
} from '../../../components/v2/styled';
import { StyledKnowledgeSubject } from '../../../components/v2/styled/knowledge/Subject';
import { StyledKnowledgeLesson } from '../../../components/v2/styled/knowledge/Lesson';
import { SnackError } from '../../../components/v2/snacks/Error';
import { CardBase } from '../../../components/v2/cards/Base';
import { StyledKnowledgeQuiz } from '../../../components/v2/styled/knowledge/Quiz';

import { KnowledgeCourse } from '../../../models/KnowledgeCourse';
import { KnowledgeSubscription } from '../../../models/KnowledgeSubscription';
import { KnowledgeSubject } from '../../../models/KnowledgeSubject';
import { KnowledgeLesson } from '../../../models/KnowledgeLesson';

import HelpersLanguage from '../../../actions/helpers/language';

const { DateTime } = require("luxon");

type Props = {}

export const ClientKnowledgeCourseSubscriptionLesson: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();

  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [lessonId, setLessonId] = useState<string | undefined>(params.lessonId);
  const [object, setObject] = useState<KnowledgeSubscription>();
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("created_at DESC");
  const [search, setSearch] = useState<string>("");
  const [videoActiveLanguage, setVideoActiveLanguage] = useState<string>(i18n.resolvedLanguage || 'nl');
  const [showError, setShowError] = useState<string>();

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);
  const [isLessonActuallyDisabled, setIsLessonActuallyDisabled] = useState<boolean>(false);
  const [subjectQuizWorthy, setSubjectQuizWorthy] = useState<boolean>(false);
  const [courseQuizWorthy, setCourseQuizWorthy] = useState<boolean>(false);

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["client", "knowledge_sub", objectId, {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<KnowledgeSubscription>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_subscription',
          fields: [
            'id', 'finished_at', 'lesson_key', 'subject_data', 'lesson_data', 'extra_data', 'mollie_data', 'ends_at', 'is_approved', 'approved_at', 'knowledge_course', 'updated_at'
          ],
          sub_fields: {
            practice: ['id', 'name', 'get_item', 'get_medium'],
            knowledge_course: ['id', 'full_name', 'full_teaser', 'full_body', 'extra_data', 'get_item', 'is_bg_color', 'practice', 'knowledge_subjects', 'knowledge_lessons', 'access_data', 'mollie_data', 'knowsub', 'is_open_order', 'course_type'],
            knowledge_subjects: ['id', 'full_name', 'full_body', 'knowledge_lessons', 'is_open_order', 'extra_data'],
            knowledge_lessons: ['id', 'full_name', 'videos', 'attachments', 'is_video_lesson', 'extra_data'],
            knowsub: ['id', 'created_at']
          },
          order: order,
          per_page: 1,
          page: 0,
          filter: {
            search: search,
            advanced: {
              lesson_key: objectId
            }
          }
        },
        login
      ),
    select: (d) => {
      // count = d.count;
      return d.result;
    },
    enabled: !!objectId,
  });

  const {
    data: objectLesson,
    isLoading: objectLessonLoading,
    isError: objectLessonError,
    isSuccess: objectLessonSuccess,
    refetch: objectLessonRefetch,
  } = useQuery({
    queryKey: ["client", "knowledge_lesson", objectId, lessonId, {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_one<KnowledgeLesson>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_lesson',
          fields: [
            'id', 'full_name', 'videos', 'attachments', 'is_video_lesson', 'extra_data', 'knowledge_subject', 'knowledge_course', 'full_body', 'quiz_id', 'quiz',
            'access_data'
          ],
          sub_fields: {
            knowledge_subject: ['id', 'extra_data', 'quiz'],
            knowledge_course: ['id', 'quiz'],
            quiz: ['id', 'name', 'extra_data']
          },
          id: lessonId
        },
        login
      ),
    enabled: !!lessonId && !!object?.id,
  });







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{custom_result: any}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      if (!!data.custom_result?.url) navigate(data.custom_result?.url);
      if (!!data.custom_result?.message) setShowError(data.custom_result?.message);
    },
  });

  const isSubjectDisabled = (subject:KnowledgeSubject , i:number) => {
    let disabled = false;
    if (!object) return true;

    disabled = !(
      (!!object?.knowledge_course?.is_open_order) || 
      (
        !object?.knowledge_course?.is_open_order && 
        (object?.lesson_data?.completed?.subjects || []).indexOf(subject?.id || 0) < 0 && 
        (
          !(object.knowledge_course?.knowledge_subjects || [])[i - 1]?.id ||
          (object?.lesson_data?.completed?.subjects || []).indexOf((object.knowledge_course?.knowledge_subjects || [])[i - 1]?.id || 0) > -1
        )
      )
    );

    return disabled
  }
  const isLessonDisabled = (subject:KnowledgeSubject, lesson:KnowledgeLesson , i:number, ii:number) => {
    let disabled = false;
    if (!object) return true;
    if ((object?.lesson_data?.completed?.lessons || []).indexOf(lesson?.id || 0) > -1) return false;
    if (parseInt(lesson?.access_data?.day_from_start || "0", 10) > 0 && DateTime.fromISO(object?.approved_at).plus({day: parseInt(lesson?.access_data?.day_from_start || "0", 10)}).startOf("day") > DateTime.now().startOf("day")) return true;

    disabled = (!!isSubjectDisabled(subject, i) || (!isSubjectDisabled(subject, i) && !(
      (!!subject?.is_open_order) || 
      (
        !subject?.is_open_order && 
        (object?.lesson_data?.completed?.lessons || []).indexOf(lesson?.id || 0) < 0 && 
        (
          !(subject?.knowledge_lessons || [])[ii - 1]?.id ||
          (object?.lesson_data?.completed?.lessons || []).indexOf((subject?.knowledge_lessons || [])[ii - 1]?.id || 0) > -1
        )
      )
    )));

    return disabled
  }

  const selectContentWithId = (field?:{[z:string]: string}, extraFallback?:string|JSX.Element) => {
    let correct = (field || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')];
    if (!!correct) return correct;
    let fallback = (field || {})['nl'];
    if (!!fallback) return fallback;
    let anyFallback = Object.values(field || {}).filter(fff => !!fff)[0];
    if (!!anyFallback) return anyFallback;
    if (!!extraFallback) return extraFallback;
    return t("general.translation_fallbacks.no_translation_available")
  }









  const endLesson = (i:number) => {
    mutationCustomAction.mutate({
      formData: {
        object: 'knowledge_subscription',
        class_action: 'custom_api_lesson_end',
        lesson_key: objectId,
        lesson_id: i,
        user_id: login?.id
      }
    });
  }

  useEffect(() => {
    if (params.id !== 'new') objectsRefetch();
  }, [params.id]);
  useEffect(() => {
    if ((objects || []).length === 1) setObject((objects || [])[0]);
  }, [objects]);
  useEffect(() => {
    setVideoActiveLanguage(i18n.resolvedLanguage || 'nl');
  }, [i18n.resolvedLanguage]);
  useEffect(() => {
    if (!!object && !!objectLesson) {
      (object.knowledge_course?.knowledge_subjects || []).forEach((subject, i) => {
        (subject.knowledge_lessons || []).forEach((lesson, ii) => {
          if (lesson?.id === objectLesson?.id) {
            setIsLessonActuallyDisabled(isLessonDisabled(subject, lesson, i, ii));

            let lesson_ids = (object?.lesson_data?.completed?.lessons || []);
            let lessons_in_sub_ids = (subject.knowledge_lessons || []).map(mm => mm.id);
            setSubjectQuizWorthy(lesson_ids.length === (lessons_in_sub_ids.length - 1));

            if (lesson_ids.length === (lessons_in_sub_ids.length - 1)) {
              let subject_ids = (object?.lesson_data?.completed?.subjects || []);
              let subjects_in_course_ids = (object.knowledge_course?.knowledge_subjects || []).map(mm => mm.id);
              setCourseQuizWorthy(subject_ids.length === (subjects_in_course_ids.length - 1));
            }
          }
        })
      })
    }
  }, [object, objectLesson]);

  return <Page
    title={selectContentWithId(objectLesson?.full_name || {}, <CircularProgress />)}
    titleCrumbs={[
      {
        title: t("client.menu.knowledge_center"),
        path: "/knowledge_center"
      }
    ]}
  >
    <Grid container spacing={1}>
      {!!object && !(!object.ends_at || (!!object.ends_at && DateTime.fromISO(object.ends_at) > DateTime.now())) && <Grid item xs={12} md={8}>
        <Typography html sx={{
          borderRadius: 1,
          border: '1px solid transparent',
          borderColor: theme.palette.warning.main,
          padding: 2,
          textAlign: 'center'
        }}>{t("client.course.warnings.subscription_ended")}</Typography>
      </Grid>}
      {!!object && (!object.ends_at || (!!object.ends_at && DateTime.fromISO(object.ends_at) > DateTime.now())) && <>
        {!object.is_approved && <Grid item xs={12} md={8}>
          <Typography html sx={{
            borderRadius: 1,
            border: '1px solid transparent',
            borderColor: theme.palette.warning.main,
            padding: 2,
            textAlign: 'center'
          }}>{t("client.course.warnings.not_approved")}</Typography>
        </Grid>}




        {!!object.is_approved && <>
          {object?.knowledge_course?.course_type === 0 && !!isLessonActuallyDisabled && <Grid item xs={12} md={8}>
            <Typography html sx={{
              borderRadius: 1,
              border: '1px solid transparent',
              borderColor: theme.palette.warning.main,
              padding: 2,
              textAlign: 'center'
            }}>{t("client.course.warnings.lesson_disabled")}</Typography>
          </Grid>}
          {!(object?.knowledge_course?.course_type === 0 && !!isLessonActuallyDisabled) && <>
            {(object?.knowledge_course?.access_data?.availability || [1]).map(m => parseInt(m.toString(), 10)).indexOf(HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')) < 0 && <Grid item xs={12} md={12}>
              <Typography html sx={{
                borderRadius: 1,
                border: '1px solid transparent',
                borderColor: theme.palette.warning.main,
                padding: 2,
                textAlign: 'center'
              }}>{t(object?.knowledge_course?.course_type === 1 ? "client.course.knowledge_warnings.wrong_language" : "client.course.warnings.wrong_language")}</Typography>
            </Grid>}



            {Object.values(objectLesson?.videos || {}).filter(fff => !!fff).length > 0 && <Grid item xs={12}>
              <video id="video" controls style={{objectFit: 'contain', width: '100%'}}>
                <source src={`${(objectLesson?.videos || {})[videoActiveLanguage].get_item}?${videoActiveLanguage}`} type="video/mp4"/>
              </video>
              <Typography sx={{
                textDecoration: 'underline'
              }}>{t("client.course.subtitles.video_available_in")}</Typography>
              <Box sx={{
                height: '40px',
                display: 'flex',
                flexDirection: 'row'
              }}>
                {Object.keys(objectLesson?.videos || {}).filter(fff => !!(objectLesson?.videos || {})[fff]).map(l => <Avatar
                  sx={{
                    backgroundColor: l === videoActiveLanguage ? theme.palette.primary.main : 'white',
                    color: l === videoActiveLanguage ? 'white' : theme.palette.primary.main,
                    border: '1px solid white',
                    borderColor: l === videoActiveLanguage ? 'white' : theme.palette.primary.main,
                    marginRight: 1,
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setVideoActiveLanguage(l);
                    var video = document.getElementById('video');
                    // @ts-ignore
                    video.load();
                  }}
                >
                  {l}
                </Avatar>)}
              </Box>
            </Grid>}
            <Grid item xs={12}>
              <CardBase sx={{height: 'auto'}}>
                <CardContent>
                  <Typography html>{selectContentWithId(objectLesson?.full_body || {}, ' ')}</Typography>
                </CardContent>
              </CardBase>
            </Grid>



            {object?.knowledge_course?.course_type === 0 && <Grid item xs={12} md={4}>
              <CardBase sx={{height: 'auto'}}>
                <CardContent>
                  {selectContentWithId(objectLesson?.full_public_duration || {}, '.') !== '.' && <>
                    <Typography sx={{fontWeight: 'bold'}}>{t("client.course_lesson.stats.lesson_duration")}</Typography>
                    <Typography html>{selectContentWithId(objectLesson?.full_public_duration || {}, ' ')}</Typography>
                  </>}
                  <Typography sx={{fontWeight: 'bold'}}>{t("client.course_lesson.stats.lesson_started")}</Typography>
                  <Typography html><Dt d={((object.lesson_data?.lesson_stats || {})[(objectLesson?.id || 0).toString()] || {}).started} f="DDD t" /></Typography>
                  {!!((object.lesson_data?.lesson_stats || {})[(objectLesson?.id || 0).toString()] || {}).ended && <>
                    <Typography sx={{fontWeight: 'bold'}}>{t("client.course_lesson.stats.lesson_ended")}</Typography>
                    <Typography html><Dt d={((object.lesson_data?.lesson_stats || {})[(objectLesson?.id || 0).toString()] || {}).ended} f="DDD t" /></Typography>
                  </>}
                </CardContent>
              </CardBase>
            </Grid>}
            <Grid item xs={12} md={4}>
              {(!!objectLesson?.quiz) && <CardBase sx={{height: 'auto'}}>
                <CardContent>
                  {!!objectLesson?.quiz && <>
                    <Typography sx={{
                      marginBottom: 1
                    }}>{t(`client.course_lesson.${object?.knowledge_course?.course_type === 1 ? "knowledge_" : ""}stats.lesson_has_quiz`)}</Typography>
                    <StyledKnowledgeQuiz
                      questionnaire={objectLesson?.quiz}
                    />
                  </>}

                  {!!subjectQuizWorthy && !!objectLesson?.knowledge_subject?.quiz && <>
                    <Typography sx={{
                      marginBottom: 1,
                      marginTop: 1
                    }}>{t("client.course_lesson.stats.subject_has_quiz")}</Typography>
                    <StyledKnowledgeQuiz
                      questionnaire={objectLesson?.knowledge_subject?.quiz}
                    />
                  </>}

                  {!!courseQuizWorthy && !!objectLesson?.knowledge_course?.quiz && <>
                    <Typography sx={{
                      marginBottom: 1,
                      marginTop: 1
                    }}>{t(`client.course_lesson.${object?.knowledge_course?.course_type === 1 ? "knowledge_" : ""}stats.course_has_quiz`)}</Typography>
                    <StyledKnowledgeQuiz
                      questionnaire={objectLesson?.knowledge_course?.quiz}
                    />
                  </>}
                </CardContent>
              </CardBase>}
            </Grid>
            <Grid item xs={12} md={4}>
              <CardBase sx={{height: 'auto'}}>
                <CardContent>
                  <Button
                    label={t(object?.knowledge_course?.course_type === 1 ? "client.course.knowledge_actions.end_lesson" : "client.course.actions.end_lesson")}
                    id="end_lesson"
                    color="primary"
                    onClick={() => {
                      endLesson(objectLesson?.id || 0);
                    }}
                    startIcon={<TaskIcon />}
                    sx={{
                      border: '1px solid transparent',
                      borderColor: theme.palette.primary.main,
                      marginTop: 0,
                      width: '100%'
                    }}
                  />
                </CardContent>
              </CardBase>
            </Grid>
            {((objectLesson?.attachments || {})[i18n.resolvedLanguage || 'nl'] || []).length > 0 && <Grid item xs={12}>
              <CardBase sx={{height: 'auto'}}>
                <CardContent>
                  <Typography sx={{fontWeight: 'bold'}}>{t("client.course_lesson.title.attachments")}</Typography>
                  <Divider />
                  <List>
                    {((objectLesson?.attachments || {})[i18n.resolvedLanguage || 'nl'] || []).map((item, i) => <ListItem
                      divider={i < ((objectLesson?.attachments || {})[i18n.resolvedLanguage || 'nl'] || []).length -1}
                      onClick={() => {
                        window.open(item.get_item, "_BLANK");
                      }}
                      sx={{
                        cursor: 'pointer'
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar>
                          <Attachment />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={item.item_file_name.replaceAll("%20", " ")} />
                    </ListItem>)}
                  </List>
                </CardContent>
              </CardBase>
            </Grid>}







          </>}
        </>}
      </>}
    </Grid>

    <SnackError
      error={showError}
      open={!!showError}
      setOpen={() => {
        setShowError(undefined);
      }}
    />
  </Page>;
}
